module.exports = "/packs/thankyou-dbbc5bbf638da008c4f4d49b9623463b.png";